// extracted by mini-css-extract-plugin
export default {"details":"styles_details__CkQSE","cardRow":"styles_cardRow__023UV"};